import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "max-w-xs max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl border-r border-b border-l border-gray-400 border-t bg-white rounded-b lg:rounded-r p-8 my-4 mx-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "text-gray-700 text-base" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.user && _ctx.user.userType == 'twitter.com')
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            ref: "imageRef",
            class: "h-40 object-cover rounded-md",
            src: (_ctx.user?.user?.photoURL as string),
            alt: "twitter photo"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(" twitterName: " + _toDisplayString(_ctx.user?.user?.displayName) + " ", 1),
              _hoisted_6
            ])
          ]),
          _createElementVNode("button", {
            class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signout && _ctx.signout(...args))),
            id: "SignOutTwitter"
          }, _toDisplayString(_ctx.$t("function.signout")), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_7, [
        _createElementVNode("button", {
          class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signin && _ctx.signin(...args))),
          id: "SignInTwitter"
        }, _toDisplayString(_ctx.$t("function.signinTwitter")), 1)
      ]))
}